import React, { useEffect, useState } from 'react';
import { Layout, Menu } from 'antd';
import { Link } from 'react-router-dom';
import Styled from 'styled-components';
import { Auth } from 'aws-amplify';
import { LogoutOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import logo from '../assets/logo.png';

const { Header } = Layout;

const MainHeader = (props) => {
  const [userIsLogged, setUserIsLogged] = useState(false);

  async function signOut() {
    try {
      await Auth.signOut();
      setUserIsLogged(false);
      const { history: { replace } } = props;
      replace('/');
    } catch (error) {
      console.log('error signing out: ', error);
    }
  }

  useEffect(async () => {
    const auth = await Auth.currentCredentials();
    setUserIsLogged(auth?.authenticated || false);
    // eslint-disable-next-line no-debugger
    // debugger;
    console.log(userIsLogged, 'userIsLogged');
  }, []);

  return (
    <Header>
      <div className="logo">
        <Logo>
          <Link to="/"><img src={logo} alt="Logo" width="50%" /></Link>
        </Logo>
      </div>
      <Menu theme="dark" mode="horizontal" defaultSelectedKeys={['2']}>
        <Menu.Item key="2">
          <Link to="/calculateur-simulant">Calculateur</Link>
        </Menu.Item>
        <Menu.Item key="4">
          <Link to="/authForm">Mes recettes</Link>
        </Menu.Item>
        {/* eslint-disable-next-line react/jsx-no-bind */}
        <Menu.Item onClick={signOut} key="logout">
          <LogoutOutlined />
        </Menu.Item>
      </Menu>
    </Header>
  );
};

MainHeader.propTypes = {
  history: PropTypes.shape({
    replace: PropTypes.func
  })
};

const Logo = Styled.div`
  height: 60px;
  margin: 2px 0px 2px 0px;
  text-align: center;
`;

export default MainHeader;
